import {
  FulfillmentTypeListResponseType,
  OrderFulfillmentType,
  SupplierRelationshipGetResponseType,
} from "@sellar-io/api-v2/types";
import { createContext } from "react";
import {
  CustomDiscountType,
  OrderDiscountType,
  OrderOnBehalfOfOrderItemType,
} from "../pages/order/orderOnBehalfOf/OrderOnBehalfOf.shared";

export const OrderOnBehalfOfContext = createContext<
  | {
      orderItems: OrderOnBehalfOfOrderItemType[];
      setOrderItems: (orderItems: OrderOnBehalfOfOrderItemType[]) => void;
      editingProductId?: number;
      setEditingProductId: (productId?: number) => void;
      fulfillmentType: OrderFulfillmentType;
      calculatedDeliveryCharge: number;
      customDeliveryCharge?: number;
      customDiscount?: CustomDiscountType;
      customDiscountAmount?: number;
      priceTierDiscountList: OrderDiscountType[];
      priceTierDiscountAmount: number;
      connection: SupplierRelationshipGetResponseType;
      fulfillmentTypeContainerDeliveryCharges: FulfillmentTypeListResponseType[number]["FulfillmentTypeContainerDeliveryCharges"];
    }
  | undefined
>(undefined);
